"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartWrapperPropTypes = exports.default = exports.DEFAULT_SUBTITLE_FONT_SIZE = exports.DEFAULT_TITLE_FONT_SIZE = void 0;
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_resize_detector_1 = require("react-resize-detector");
const constants_1 = require("../../utilities/constants");
const Dropdown_1 = __importDefault(require("../Dropdown"));
const Footer_1 = __importDefault(require("../Footer"));
const types_1 = require("../Footnotes/types");
const types_2 = require("../Sources/types");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
exports.DEFAULT_TITLE_FONT_SIZE = 20;
exports.DEFAULT_SUBTITLE_FONT_SIZE = 16;
function renderSlot(el) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!el) {
    return null;
  }
  if (typeof el === 'function') {
    return el(...args);
  }
  return el;
}
const ChartWrapper = _ref => {
  let {
    /** Req Data */
    children,
    slotAboveChart = undefined,
    slotBelowChart = undefined,
    /** Header/Footer Options */
    title = '',
    subtitle = '',
    titleFontSize = exports.DEFAULT_TITLE_FONT_SIZE,
    subtitleFontSize = exports.DEFAULT_SUBTITLE_FONT_SIZE,
    footerSources = [],
    footerSummary,
    footnotes = [],
    showFooter = true,
    /** Styling */
    width,
    height = 'auto',
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    className = '',
    style = {},
    dropdowns = [],
    /** Events */
    onMouseLeave = () => {}
  } = _ref;
  const ref = (0, react_1.useRef)();
  const {
    width: chartWidth = 0,
    height: chartHeight = 0
  } = (0, react_resize_detector_1.useResizeDetector)({
    targetRef: ref,
    refreshMode: 'debounce',
    refreshRate: 500,
    refreshOptions: {
      leading: true,
      trailing: true
    }
  });
  return react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['chart-wrapper']} ${className}`,
    style: {
      ...style,
      width: width || null,
      minHeight: height || 0,
      fontSize
    }
  }, (title || dropdowns.length !== 0) && react_1.default.createElement("div", {
    className: styles_module_css_1.default['chart-title'],
    style: {
      fontSize: titleFontSize
    }
  }, title && react_1.default.createElement("span", {
    className: "title-text"
  }, title), dropdowns.length !== 0 && react_1.default.createElement("span", {
    className: styles_module_css_1.default['dropdown-container']
  }, dropdowns.map(dropdown => react_1.default.createElement(Dropdown_1.default, {
    key: JSON.stringify(dropdown),
    ...dropdown
  })))), subtitle && react_1.default.createElement("div", {
    className: styles_module_css_1.default['chart-subtitle'],
    style: {
      fontSize: subtitleFontSize
    }
  }, subtitle), react_1.default.createElement("div", {
    className: styles_module_css_1.default['chart-content']
  }, slotAboveChart && renderSlot(slotAboveChart, [{
    chartHeight,
    chartWidth
  }]), react_1.default.createElement("div", {
    ref: ref,
    style: {
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap'
    },
    onMouseLeave: onMouseLeave,
    onBlur: () => {}
  }, renderSlot(children, [{
    chartHeight,
    chartWidth
  }])), slotBelowChart && renderSlot(slotBelowChart, [{
    chartHeight,
    chartWidth
  }])), showFooter && react_1.default.createElement(Footer_1.default, {
    sources: footerSources,
    summary: footerSummary,
    footnotes: footnotes,
    fontSize: fontSize
  }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ;
};

exports.default = ChartWrapper;
const chartWrapperPropTypes = {
  /** Req Data */
  /** Child node */
  children: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func]),
  /** Legend Slot */
  slotLegend: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func]),
  /** Header/Footer Options */
  /** Chart Title */
  title: prop_types_1.string,
  /** Chart Subtitle */
  subtitle: prop_types_1.string,
  /** Title font size */
  titleFontSize: prop_types_1.number,
  /** Subtitle font size */
  subtitleFontSize: prop_types_1.number,
  /** Footer sources */
  footerSources: (0, prop_types_1.arrayOf)(types_2.sourcesType),
  /** footer summary */
  footerSummary: prop_types_1.string,
  /** Footer footnotes */
  footnotes: (0, prop_types_1.arrayOf)(types_1.customFootnoteType),
  /** Shows the footer */
  showFooter: prop_types_1.bool,
  /** Disables footnotes from metrics */
  /** Styling */
  /** Width to draw the chart. Will fill container if unset. */
  width: prop_types_1.number,
  /** Height to draw the chart */
  height: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
  /** sets default font size for chart body elements and footer */
  fontSize: prop_types_1.number,
  /** Chart classname */
  className: prop_types_1.string,
  /** Custom styles for chart wrapper */
  style: prop_types_1.object,
  /** Dropdown in header */
  dropdowns: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    options: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])),
    color: prop_types_1.string,
    label: prop_types_1.string,
    value: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    parser: prop_types_1.func,
    onChange: prop_types_1.func.isRequired
  })),
  /** Events */
  /** On chart mouseout */
  onMouseLeave: prop_types_1.func
};
exports.chartWrapperPropTypes = chartWrapperPropTypes;
ChartWrapper.propTypes = {
  ...chartWrapperPropTypes
};